import React, { Component } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';


class EventModal extends Component {
    componentDidMount() {
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#EventModal').modal('hide');
    }

    closeAction = () => {
        const { CloseActions } = this.props;
        $('#EventModal').on('hidden.bs.modal', function () {
            if (CloseActions) {
                CloseActions()
            }
        });
    };
    render() {
        const { title, body, footer } = this.props

        return (
            <>
                <div className="modal fade bd-example-modal-xl modal-open scroll" id="EventModal" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">

                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ background: "#343a40" }}>
                                {title}
                            </div>
                            <div className="modal-body">
                                <div className="container">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            {body}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {footer}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

export default connect(
    mapStateToProps,
)(EventModal);